var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTileTurquoise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1 {\r\n                fill: #d9f8ff;\r\n            }\r\n\r\n            .cls-2 {\r\n                fill: #00c4f9;\r\n            }\r\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    width: 100,
    height: 100
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85,5h-16.36V28.8l-16.83,16.83V21.83L68.64,5H31.36l16.83,16.83v23.8L31.36,28.8V5H15c-3.91,3.91-6.09,6.09-10,10V31.36H28.8l16.83,16.83H21.83L5,31.36v37.28l16.83-16.83h23.8l-16.83,16.83H5v16.36l10,10H31.36v-23.8l16.83-16.83v23.8l-16.83,16.83h37.28l-16.83-16.83v-23.8l16.83,16.83v23.8h16.36c3.91-3.91,6.09-6.09,10-10v-16.36h-23.8l-16.83-16.83h23.8l16.83,16.83V31.36l-16.83,16.83h-23.8l16.83-16.83h23.8V15l-10-10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileTurquoise);
export default __webpack_public_path__ + "static/media/tile-turquoise.e25121c6aa4153cb0a6481da8fb0c12e.svg";
export { ForwardRef as ReactComponent };